module.exports = __webpack_public_path__ + "static/blueforce-321fee7ac27675ba2f63134c781a32c8.svg";